import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import { ClientFormUpdate } from './ClientForm';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';

const ClientDetails = () => {
  const location = useLocation();
  const history = useHistory();
  const [editMode, setEditMode] = useState(false);
  const [clientKits, setClientKits] = useState([]);
  const [client, setClient] = useState({ Nom: '', Appareils: [], Kits: [] });
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorKit, setAnchorKit] = useState(null);
  const [users, setUsers] = useState([]);
  const [kits, setKits] = useState([]);

  useEffect(() => {
    if (location.state) {
      setEditMode(Boolean(location.state.editMode));
    }
    fetch(process.env.REACT_APP_PROXY_HOST + '/gere' + location.pathname, { method: 'GET' })
      .then((res) => res.json())
      .then((loadedClient) => {
        setClient(loadedClient);
        setClientKits(loadedClient.Kits || []);
      });
  }, [location]);

  const handleSSUserClick = (user) => {
    setClient({ ...client, SyncStatsAccountId: user.noCompte, SyncStatsAccountName: user.username });
    setAnchorEl(null);
  };

  const handleKitClick = (kit) => {
    const tmpKits = [...clientKits, kit];
    setClientKits(tmpKits);
    setClient({ ...client, Kits: tmpKits });
    setAnchorKit(null);
  };

  const handleDelete = () => {
    if (!client._id) {
      return;
    }
    fetch(process.env.REACT_APP_PROXY_HOST + '/liste/clients/' + client._id, { method: 'DELETE' })
      .then(() => history.push('/clients'));
  };

  const showAppareil = (appareil) => {
    history.push({ pathname: '/device/' + appareil._id, appareilid: appareil._id, state: { appareil, editMode } });
  };

  const showKit = (kit) => {
    history.push({ pathname: '/kit/' + kit._id, kitid: kit._id, state: { kit, editMode } });
  };

  const showUserList = (event) => {
    fetch(process.env.REACT_APP_PROXY_HOST + '/liste/users')
      .then((res) => res.json())
      .then((json) => setUsers(json));
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const showKitList = (event) => {
    fetch(process.env.REACT_APP_PROXY_HOST + '/liste/kits')
      .then((res) => res.json())
      .then((json) => setKits(json));
    setAnchorKit(anchorKit ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;
  const openKit = Boolean(anchorKit);
  const kitId = openKit ? 'simple-popper-kit' : undefined;

  return (
    <div>
      <h1>Client</h1>
      <p>Nom de Compte Syncstats: {client.SyncStatsAccountName}</p>
      <p>Numero de Compte Syncstats: {client.SyncStatsAccountId}</p>
      <p>Compte Dolibarr: {client.DoliId}</p>
      <FormControlLabel control={<Checkbox checked={editMode} onChange={() => setEditMode(!editMode)} name="editMode" color="primary" />} label="Modifer?" />
      <h3>Appareils</h3>
      <List component="nav" aria-label="secondary mailbox folders">
        {(client.Appareils || []).map((appareil) => (
          <ListItem button key={appareil._id} onClick={() => showAppareil(appareil)}>
            <ListItemText primary={appareil.no} />
            <ListItemText primary={appareil.fonction} />
            <ListItemText primary={appareil.telId} />
          </ListItem>
        ))}
      </List>
      <h3>Kits</h3>
      <List component="nav" aria-label="secondary mailbox folders">
        {(client.Kits || []).map((kit) => (
          <ListItem button key={kit._id} onClick={() => showKit(kit)}>
            <ListItemText primary={kit.no} />
          </ListItem>
        ))}
      </List>
      {editMode && <div><Button id="btn-users" variant="contained" onClick={showUserList}>Choisir SyncStats User</Button><ClientFormUpdate formData={client} dbid={client._id} /></div>}
      <Popper id={id} open={open} anchorEl={anchorEl}>
        <Paper>
          <List component="nav" aria-label="secondary mailbox folders">
            {users.map((user) => (
              <ListItem button key={user._id || user.username} onClick={() => handleSSUserClick(user)}>
                <ListItemText primary={user.username} />
              </ListItem>
            ))}
          </List>
        </Paper>
      </Popper>
      {editMode && <div><Button id="btn-kits" variant="contained" onClick={showKitList}>Choisir Kit</Button></div>}
      <Popper id={kitId} open={openKit} anchorEl={anchorKit}>
        <Paper>
          <List component="nav" aria-label="secondary mailbox folders">
            {kits.map((kit) => (
              <ListItem button key={kit._id || kit.no} onClick={() => handleKitClick(kit)}>
                <ListItemText primary={kit.no} />
                <ListItemText primary={kit.description} />
              </ListItem>
            ))}
          </List>
        </Paper>
      </Popper>
      <Button variant="contained" onClick={handleDelete}>Effacer</Button>
    </div>
  );
};

export default ClientDetails;



// WEBPACK FOOTER //
// src/components/clients/ClientDetails.js